<style src="./style.scss">
</style>

<script>
  import { afterUpdate } from "svelte";

  import ArrowLeftIcon from "@assets/icons/arrow-left.svg";
  import Badge from "@components/badge";
  import BillingFrequency from "@components/billingFrequency";
  import Button from "@components/button";
  import CardLockedImage from "@assets/images/card-locked.gif";
  import CardRefusedImage from "@assets/images/card-refused.gif";
  import CardWithIncorrectInfoImage from "@assets/images/card-with-incorrect-info.gif";
  import CardWithoutLimitImage from "@assets/images/card-without-limit.gif";
  import CreditCard from "@components/creditCard";
  import DebitCardImage from "@assets/images/debit-card.gif";
  import Footer from "@components/footer";
  import Header from "@components/header";
  import HeartIcon from "@assets/icons/heart.svg";
  import CheckIcon from "@assets/icons/check.svg";
  import Icon from "svelte-icon";
  import Modal from "@components/modal";
  import Plan from "@components/plan";
  import Spinner from "@components/spinner";
  import SubscriptionModal from "./modals/subscrption.svelte";
  import PaymentErrorModal from "@components/paymentErrorModal";
  import TextInput from "@components/textInput";
  import Toast from "@components/toast";
  import { onError } from "@apollo/client/link/error";
  import { query, mutation } from "svelte-apollo";
  import { navigate } from "svelte-navigator";
  import { useLocation } from "svelte-navigator";
  import { email as storedEmail, authType } from "@store";
  import { captureException } from "@integrations/sentry.ts";
  import { postAffiliate } from "@integrations/postaffiliate.ts";
  import { tapfiliate } from "@integrations/tapfiliate.ts";
  import { generateCaptchaTokenOnSubmit } from "@integrations/captcha.ts";
  import { datalayerTrack } from "@integrations/dataLayer";
  import { isFullNameValid } from "@utils/account";

  import {
    parseQuery,
    uuidv4,
    formatCurrency,
    isValidExpirationDate,
    validateCpf,
    getScreenSize,
    TERMS_LINK,
    PRIVACITY_LINK,
  } from "@utils";
  import {
    AmericamExpressCardIcon,
    EloCardIcon,
    HiperCardCardIcon,
    HiperCardIcon,
    MasterCardIcon,
    VisaCardIcon,
  } from "@assets/icons/cards";

  import { DISCOUNT_MUTATION } from "./discount.mutation.ts";
  import { PRODUCTS_QUERY } from "./products.query.ts";
  import { VERIFY_EMAIL_QUERY } from "./verifyEmail.query.ts";
  import { PURCHASE_MUTATION } from "./purchase.mutation.ts";
  import { SUBSCRIPTION_QUERY } from "./subscription.query.ts";

  let isValidEmail = (value) => {
    const pattern = /\S+@\S+\.\S+/;
    return pattern.test(value);
  };

  const location = useLocation();

  let plan;
  let prices = [];
  let price;
  let discount = {};
  let discountButtonText = "Adicionar";
  let currentDate = new Date().toLocaleDateString("pt-br");
  let promotionCode = "";
  let previousPromotionCode = null;
  let planDetailsModal = false;
  let subscriptionModal = false;
  let isLoading = false;
  let paymentErrorModal = false;
  let paymentErrorModalMessage = "";
  let expirationDate = "";
  let securityCode = "";
  let cardNumber = "";
  let holder = "";
  let paymentError = {};
  let email = "";
  let phone = "";
  let phoneMask = "00 0 0000-0000";
  let cpf = "";
  let hasEmail = false;
  let validEmail = true;
  let validCpf = true;
  let isFetchingEmail = false;
  let previousDiscount = {};
  let subscribedProduct = null;
  let subscribedStatus = "";
  let currentEmail = "";
  let disableSumbmit = false;
  let fullName = "";
  let hasValidName = true;

  const screenWidth = getScreenSize().width;
  let message = {
    error: "",
    visible: false,
    text: "",
    toastType: "",
  };

  function disabledFields() {
    return (
      discount?.amount || (!hasEmail && validEmail) || (!validEmail && hasEmail)
    );
  }

  const queryParams = parseQuery($location.search);

  function showMessage(text, toastType) {
    message = {
      toastType,
      text,
      visible: true,
    };
  }

  function clearMessage() {
    message = { visible: false, text: "", toastType: "alert" };
  }

  authType.subscribe((value) => {
    if (value === "sign-up") {
      showMessage(
        "Prontinho! A sua conta foi criada! Agora falta pouco para você aprender inglês com o CNA Go."
      );
    }
  });

  const products = query(PRODUCTS_QUERY, {
    variables: {
      condition: {
        active: true,
      },
    },
  });

  const purchase = mutation(PURCHASE_MUTATION);
  const calculateDiscount = mutation(DISCOUNT_MUTATION);
  const verifyEmailQuery = query(VERIFY_EMAIL_QUERY, {
    variables: { input: { email } },
  });

  function getAmount() {
    return `${
      discount?.amount || discount?.amount === 0
        ? formatCurrency(discount?.amount)
        : price
        ? formatCurrency(price.price)
        : null
    }`;
  }

  function getDiscount() {
    return `${formatCurrency(discount?.discount || 0)}`;
  }

  function getFullPrice() {
    return `${formatCurrency(price?.price)}`;
  }

  function getPriceRecurringInterval() {
    return price?.recurringInterval;
  }

  const createBuyIntentionEvent = () =>
    datalayerTrack({
      product: `${plan.name} - ${price.name}`,
      full_price: getFullPrice(),
      amount: getAmount(),
      discount: getDiscount(),
      promocode: promotionCode.toUpperCase(),
      id: uuidv4(),
      event: "buy_intention",
    });

  const createPaymentFinishedEvent = ({ customerId, transactionId }) => {
    datalayerTrack({
      fullname: holder,
      product: `${plan.name} - ${price.name}`,
      email,
      full_price: getFullPrice(),
      amount: getAmount(),
      discount: getDiscount(),
      promocode: promotionCode.toUpperCase(),
      transaction_id: transactionId,
      recurring_interval: getPriceRecurringInterval(),
      id: uuidv4(),
      event: "payment_finished",
    });

    datalayerTrack({
      event: "ga4_ecommerce_payment_finished",
      value: getAmount(),
      items: [
        {
          currency: "BRL",
          item_id: price.id,
          coupon: promotionCode.toUpperCase(),
          item_name: `${plan.name} - ${price.name}`,
          item_variant: getPriceRecurringInterval(),
          discount: getDiscount(),
          price: getFullPrice(),
          transaction_id: transactionId,
          quantity: 1,
        },
      ],
    });

    postAffiliate({
      discount,
      price,
      transactionId,
      promotionCode,
    });

    tapfiliate({
      customerId,
      transactionId,
      price,
      discount,
      promotionCode,
    });
  };

  afterUpdate((data) => {
    if (!plan && $products?.data?.products) {
      storedEmail.subscribe((value) => (email = value));

      if (email) {
        fetchEmail();
      }

      if (queryParams.price) {
        const product = $products?.data?.products.find(({ prices }) => {
          return prices.find(({ id }) => id === queryParams.price);
        });

        if (product) {
          selectProduct(product);

          if (queryParams.promocode) {
            promotionCode = queryParams.promocode;

            handleDiscountChange();
          }
          return;
        }
      }

      selectProduct(
        $products?.data?.products.filter(({ visible }) => visible)[0]
      );
      createBuyIntentionEvent();

      if (queryParams.promocode) {
        promotionCode = queryParams.promocode;

        handleDiscountChange();
      }
    }
  });

  function selectProduct(product) {
    plan = product;

    getProductPrices();
  }

  function hasEligibleDiscount(selectedId) {
    return plan.prices.some((_) => {
      if (
        discount?.priceIds?.length === 0 ||
        previousDiscount?.priceIds?.length === 0
      ) {
        return true;
      }

      if (discount?.priceIds) {
        return discount?.priceIds.find((value) => value === selectedId);
      }

      if (previousDiscount?.priceIds) {
        return previousDiscount?.priceIds.find((value) => value === selectedId);
      }

      return false;
    });
  }

  function selectPrice(selected) {
    price = selected;

    getDiscountValue({ changePrice: true });
  }

  function getExpirationDate(recurringInterval) {
    const today = new Date();

    switch (recurringInterval) {
      case "YEAR":
        return new Date(
          today.setFullYear(today.getFullYear() + 1)
        ).toLocaleDateString("pt-br");
        break;
      case "QUARTERLY":
        return new Date(
          today.setMonth(today.getMonth() + 3)
        ).toLocaleDateString("pt-br");
        break;
      case "SEMIANNUAL":
        return new Date(
          today.setMonth(today.getMonth() + 6)
        ).toLocaleDateString("pt-br");
        break;
      default:
        return new Date(
          today.setMonth(today.getMonth() + 1)
        ).toLocaleDateString("pt-br");
        break;
    }
  }

  function uppercase(element) {
    function onInput(event) {
      element.value = element.value.toUpperCase();
    }
    element.addEventListener("input", onInput);

    return {
      destroy() {
        element.removeEventListener("input", onInput);
      },
    };
  }

  function tryAgain() {
    paymentErrorModal = false;
  }

  async function submit() {
    hasValidName = isFullNameValid(fullName);
    
    if (!hasValidName) {
      showMessage("Digite seu nome completo", "alert");
      window.scrollTo(0, 0);
      return
    }

    if (!validateCpf(cpf)) {
      validCpf = false;
      showMessage("CPF inválido, verifique e tente novamente", "alert");
      window.scrollTo(0, 0);

      return false;
    }

    validCpf = true;

    const priceId = price?.id;
    isLoading = true;

    if (discount?.amount !== 0) {
      const splitedExpirationDate = expirationDate.split("/");

      if (splitedExpirationDate[1].length === 2) {
        expirationDate = splitedExpirationDate.join("/20");
      }
    }

    const creditCard = {
      cardNumber,
      holder,
      expirationDate,
      securityCode,
    };

    if (discount.bin) {
      const isValidBinCard = Boolean(
        discount.bin.codes.find((code) =>
          creditCard.cardNumber.startsWith(code)
        )
      );

      if (!isValidBinCard) {
        showMessage(
          `Este benefício só é concedido se você utilizar o seu cartão ${discount.bin.name}`,
          "alert"
        );

        window.scrollTo(0, 0);
        return true;
      }

      clearMessage();
    }

    if (
      !isValidExpirationDate(creditCard.expirationDate) &&
      discount?.amount !== 0
    ) {
      isLoading = false;
      showMessage(
        "Cartão vencido, verifique a data de validade do cartão",
        "alert"
      );

      window.scrollTo(0, 0);
      return true;
    }

    clearMessage();

    const captchaToken = await generateCaptchaTokenOnSubmit();

    const { data, errors } = await purchase({
      variables: {
        input: {
          priceId,
          promotionCode: promotionCode.toUpperCase(),
          ...(discount?.amount !== 0 ? { creditCard } : null),
          account: {
            name: fullName,
            email,
            cpf,
            phone: `55${phone}`,
          },
        },
      },
      context: {
        headers: { "X-Captcha": captchaToken, "x-captcha-version": "3" },
      },
      errorPolicy: "all",
    });

    if (errors) {
      captureException(errors);
      isLoading = false;
      paymentErrorModal = true;
      paymentErrorModalMessage = errors[0].message;

      return;
    }

    if (data) {
      createPaymentFinishedEvent(data.purchase);

      const successRedirectURL = getSuccessRedirectURL();

      if (subscribedStatus === "completed" && successRedirectURL) {
        window.open(successRedirectURL);

        return;
      }

      navigate(
        subscribedStatus === "completed"
          ? "/checkout-success"
          : `/create-account?email=${email}`,
        {
          state: { successRedirectURL },
        }
      );
    }
  }

  async function fetchEmail() {
    if (!isValidEmail(email)) {
      hasEmail = true;
      validEmail = false;
      return;
    } else if (email === currentEmail) {
      return;
    }

    isFetchingEmail = true;
    validEmail = true;
    currentEmail = email;
    const { data } = await verifyEmailQuery.refetch({ input: { email } });

    if (data.verifyEmail?.product) {
      subscribedProduct = data.verifyEmail?.product;
    }

    if (data.verifyEmail?.status) {
      subscribedStatus = data.verifyEmail?.status || "";
    }

    if (data.verifyEmail?.subscription) {
      window.scrollTo(0, 0);
      document.activeElement.blur();
      subscriptionModal = true;
      isFetchingEmail = false;

      return;
    }

    if (
      data.verifyEmail?.status === "completed" &&
      data.verifyEmail?.subscription
    ) {
      navigate("/checkout-success");
      return;
    }

    if (data.verifyEmail?.status === "invalid-email") {
      isFetchingEmail = false;
      validEmail = false;
      hasEmail = true;
      showMessage("E-mail inválido, tente novamente.", "alert");

      return;
    }

    isFetchingEmail = false;
    hasEmail = true;
  }

  async function getDiscountValue(options = {}) {
    const { changePrice } = options;

    if (changePrice && previousPromotionCode && !promotionCode) {
      promotionCode = previousPromotionCode;
    }

    if (promotionCode) {
      discountButtonText = "Aguarde";

      try {
        const priceId = price?.id;
        disableSumbmit = true;

        const { data } = await calculateDiscount({
          variables: {
            input: {
              priceId,
              promotionCode: promotionCode.toUpperCase(),
            },
          },
        });

        if (data.calculateDiscount) {
          discount = data.calculateDiscount;
          previousDiscount = discount;
          discountButtonText = "Remover";
          previousPromotionCode = promotionCode;

          clearMessage();

          if (discount.amount === 0) {
            holder = "";
            expirationDate = "";
            securityCode = "";
            cardNumber = "";
          }

          createBuyIntentionEvent();

          disableSumbmit = false;

          return;
        }

        if (!changePrice) {
          showMessage(
            "Este código promocional é inválido, utilize outro.",
            "alert"
          );
        }

        discountButtonText = "Adicionar";
        promotionCode = "";
        disableSumbmit = false;
      } catch (error) {
        captureException(error);
        planDetailsModal = false;
        window.scrollTo(0, 0);

        if (!changePrice) {
          showMessage(
            "Este código promocional é inválido, utilize outro.",
            "alert"
          );
        }

        discount = {};
        discountButtonText = "Adicionar";
        promotionCode = "";
        disableSumbmit = false;
      }
    }
  }

  async function handleDiscountChange() {
    if (discount?.promotionCode && queryParams.promocode) {
      discountButtonText = "Adicionar";
      previousPromotionCode = null;
      promotionCode = "";
      discount = {};

      return;
    }

    if (discount?.promotionCode && !queryParams.promocode) {
      discount = {};
      previousDiscount = {};
      promotionCode = "";
      previousPromotionCode = null;
      discountButtonText = "Adicionar";

      return;
    }

    await getDiscountValue();
  }

  function getSelectedProduct() {
    return $products.data.products.find(({ prices, id }) => id === plan);
  }

  function getProductPrices() {
    const selectedProduct = getSelectedProduct();

    prices = plan.prices;

    if (queryParams.price) {
      const selectedPrice = plan.prices.find(
        ({ id }) => id === queryParams.price
      );

      selectPrice(selectedPrice ? selectedPrice : plan.prices[0]);
      return;
    }

    selectPrice(plan.prices[0]);
  }

  function getRecurringIntervalPeriodName(interval) {
    switch (interval) {
      case "YEAR":
        return "12 meses";
        break;
      case "QUARTERLY":
        return "3 meses";
        break;
      case "SEMIANNUAL":
        return "6 meses";
        break;
      default:
        return "1 mês";
        break;
    }
  }

  function getRecurringModalPeriod(interval) {
    switch (interval) {
      case "YEAR":
        return "anual";
        break;
      case "QUARTERLY":
        return "trimestral";
        break;
      case "SEMIANNUAL":
        return "semestral";
        break;
      default:
        return "mensal";
        break;
    }
  }

  function getIntervalPeriodName(interval) {
    switch (interval) {
      case "YEAR":
        return "por ano";
        break;
      case "QUARTERLY":
        return "a cada 3 meses";
        break;
      case "SEMIANNUAL":
        return "a cada 6 meses";
        break;
      default:
        return "por mês";
        break;
    }
  }

  function showFrequencyBadges() {
    if (queryParams.price) {
      if (
        price?.recurringInterval === "QUARTERLY" ||
        price?.recurringInterval === "SEMIANNUAL"
      ) {
        return [price];
      }

      return prices?.filter(
        (data) => data.id === queryParams.price || data.visible
      );
    }

    return prices?.filter((data) => data.visible && data.active);
  }

  function onCloseSubscriptionModal() {
    subscriptionModal = false;
    email = "";
  }

  function parseProductDescription(description) {
    if (description) {
      return description.split(/\n/);
    }

    return "";
  }

  function getSuccessRedirectURL() {
    if (plan.options.length > 0) {
      const { options } = plan;

      const option = options.find(({ name }) => name === "successRedirectURL");

      return option?.value;
    }

    return null;
  }

  function getProductLinks(currentPlan, type) {
    if (currentPlan.options.length > 0) {
      const { options } = currentPlan;

      const option = options.find(({ name }) => name === type);

      if (!option) {
        if (type === "privacyPolicyURL") {
          return PRIVACITY_LINK;
        }

        if (type === "termsOfUseURL") {
          return TERMS_LINK;
        }
      }

      return option?.value;
    }

    if (type === "privacyPolicyURL") {
      return PRIVACITY_LINK;
    }

    if (type === "termsOfUseURL") {
      return TERMS_LINK;
    }

    return "";
  }
</script>

<Header steps="{[1, 2, 3]}" activeStep="{0}" />

<div class="checkout">
  <SubscriptionModal
    isOpen="{subscriptionModal}"
    product="{subscribedProduct}"
    onClose="{onCloseSubscriptionModal}" />

  <PaymentErrorModal
    isOpen="{paymentErrorModal}"
    error="{paymentErrorModalMessage}"
    tryAgain="{tryAgain}"
    onClose="{() => (paymentErrorModal = false)}" />

  <Modal
    isOpen="{planDetailsModal}"
    title="Detalhes do plano"
    onClose="{() => (planDetailsModal = false)}">
    <div>
      {#if plan}
        <div class="plan-details-modal-badge">
          <Badge title="{plan?.name}" background="{plan?.color}" />
        </div>
      {/if}
      <div class="plan-details-modal-period">
        Assinatura {getRecurringModalPeriod(price?.recurringInterval)}
      </div>
      <p>
        {#each parseProductDescription(plan?.description) as description, index}
          {#if description}
            <Icon data="{CheckIcon}" size="10px" stroke="transparent" />
            {description}<br />
          {/if}
        {/each}
      </p>

      <div class="checkout__divisor"></div>

      <div class="plan-details-modal-footer">
        <div>
          {price?.recurringInterval !== "MONTH"
            ? `${price?.installments}x`
            : ""}
        </div>
        <div>
          R$ {price ? formatCurrency(price.price / price?.installments) : null}
        </div>
      </div>
    </div></Modal>

  {#if $products.loading || isLoading}
    <Spinner />
  {:else}
    {#if message.visible}
      <div class="toast-container">
        <div>
          <Toast
            message="{message.text}"
            toastType="{message.toastType}"
            visible="{message.visible}"
            onClose="{clearMessage}" />
        </div>
      </div>
    {/if}

    <div class="checkout__container">
      <div class="checkout__content">
        <h1>Detalhes do pagamento</h1>

        {#if !queryParams.price}
          <div class="plans">
            <h2>Plano</h2>
            <div>
              {#each $products.data.products as product, index}
                {#if product.visible}
                  <Plan
                    title="{product.name}"
                    background="{product.color}"
                    active="{plan?.id === product.id}"
                    onClick="{() => selectProduct(product)}" />
                {/if}
              {/each}
            </div>
          </div>
        {/if}

        <div class="plans">
          <h2>Assinatura</h2>
          <div>
            {#each showFrequencyBadges(prices) as data}
              <BillingFrequency
                title="{data.name}"
                active="{data.id === price?.id}"
                onClick="{() => selectPrice(data)}" />
            {/each}
          </div>
        </div>
        <div>
          <TextInput
            label="Nome"
            placeholder="Digite seu nome completo"
            error="{!hasValidName}"
            bind:value="{fullName}"
            onBlur="{() => (hasValidName = isFullNameValid(fullName))}"
            type="email"
          />
        </div>
        <div class="checkout__form-control">
          <TextInput
            label="E-mail"
            placeholder="Digite seu e-mail"
            isLoading="{isFetchingEmail}"
            success="{hasEmail && validEmail}"
            error="{!validEmail && hasEmail}"
            onBlur="{fetchEmail}"
            bind:value="{email}"
            type="email" />

          <TextInput
            label="Celular"
            placeholder="Digite seu celular"
            bind:mask="{phoneMask}"
            type="tel"
            isPhone="{true}"
            bind:value="{phone}" />
        </div>

        <div class="checkout__form-control divisor-form">
          <TextInput
            label="Nome"
            placeholder="Nome no cartão"
            bind:value="{holder}"
            autocomplete="cc-csc"
            disabled="{discount?.amount === 0 ||
              (!hasEmail && validEmail) ||
              (!validEmail && hasEmail)}" />
          <TextInput
            label="CPF"
            placeholder="Digite seu CPF"
            bind:value="{cpf}"
            mask="{'000.000.000-00'}"
            error="{!validCpf}"
            type="tel"
            autocomplete="cc-csc"
            disabled="{(!hasEmail && validEmail) ||
              (!validEmail && hasEmail)}" />
        </div>

        <div class="checkout__form-control">
          <CreditCard
            disabled="{discount?.amount === 0 ||
              (!hasEmail && validEmail) ||
              (!validEmail && hasEmail)}"
            bind:expirationDate
            bind:securityCode
            bind:cardNumber />

          <div
            class="{`checkout__cards ${
              discount?.amount === 0 ||
              (!hasEmail && validEmail) ||
              (!validEmail && hasEmail)
                ? 'disabled-cards'
                : ''
            }`}">
            <Icon
              data="{VisaCardIcon}"
              size="24px"
              stroke="transparent"
              fill="#FFFFFF" />
            <Icon
              data="{MasterCardIcon}"
              size="24px"
              stroke="transparent"
              fill="#FFFFFF" />
            <Icon
              data="{AmericamExpressCardIcon}"
              size="24px"
              stroke="transparent"
              fill="#FFFFFF" />
            <Icon
              data="{EloCardIcon}"
              size="24px"
              stroke="transparent"
              fill="#FFFFFF" />
            <Icon
              data="{HiperCardCardIcon}"
              size="24px"
              stroke="transparent"
              fill="#FFFFFF" />
            <Icon
              data="{HiperCardIcon}"
              size="24px"
              stroke="transparent"
              fill="#FFFFFF" />
          </div>
        </div>

        <div class="desktop-only">
          <Button
            title="Assinar agora"
            type="success"
            onClick="{submit}"
            disabled="{discount?.amount === 0 &&
            phone !== '' &&
            cpf !== '' &&
            !disableSumbmit
              ? false
              : !expirationDate ||
                !securityCode ||
                !cardNumber ||
                !holder ||
                !phone ||
                !cpf ||
                disableSumbmit}" />
          {#if plan}
            <div class="checkout__terms">
              Declaro que li e aceitei a <a
                href="{getProductLinks(plan, 'privacyPolicyURL')}"
                target="_blank">Política de Privacidade</a>
              e os
              <a href="{getProductLinks(plan, 'termsOfUseURL')}" target="_blank"
                >Termos.</a>
            </div>
          {/if}
        </div>
      </div>

      <div class="checkout__divisor mobile-only"></div>

      <div class="checkout__content">
        <div>
          <h1>Resumo do pedido</h1>

          <div class="checkout__selected-plan">
            {#if plan}
              <Badge title="{plan?.name}" background="{plan?.color}" />
            {/if}
            <div
              class="plan-details"
              on:click="{() => (planDetailsModal = true)}">
              Detalhes do plano
              <Icon
                data="{ArrowLeftIcon}"
                size="12px"
                stroke="transparent"
                fill="#FFFFFF" />
            </div>
          </div>

          <div class="checkout__duration">
            <div>
              <div>
                <div>Duração</div>
                <div>
                  {getRecurringIntervalPeriodName(price?.recurringInterval)}
                </div>
              </div>
            </div>
            <div>
              Período de assinatura: {currentDate} - {getExpirationDate(
                price?.recurringInterval
              )}
            </div>
          </div>

          <div class="checkout__divisor"></div>

          <form
            class="checkout__discount"
            on:submit|preventDefault="{handleDiscountChange}">
            <div>
              <div>
                <TextInput
                  placeholder="Digite seu Cupom"
                  bind:value="{promotionCode}"
                  use="{uppercase}" />
                <div>Desconto do cupom</div>
                <div>
                  Total {getIntervalPeriodName(price?.recurringInterval)}
                </div>
              </div>
              <div>
                <Button
                  title="{discountButtonText}"
                  type="secondary"
                  disabled="{promotionCode === ''}" />
                <div
                  class="discount-info {discount?.discount
                    ? 'discount-value'
                    : ''}">
                  - R$ {discount?.discount
                    ? formatCurrency(
                        price?.recurringInterval === "YEAR"
                          ? discount?.discount
                          : discount?.discount
                      )
                    : "0,00"} / {price?.recurringInterval === "YEAR"
                    ? "Ano"
                    : "Mês"}
                </div>

                <div class="discount-info">
                  R$ {formatCurrency(price?.price)}
                </div>
              </div>
            </div>
          </form>
          <div class="checkout__divisor"></div>

          <div class="desktop-only">
            <div class="checkout__total">
              <div>Total</div>
              <div>
                <div>
                  {#if discount?.amount !== 0 && price?.recurringInterval !== "MONTH"}
                    {price?.installments}x
                  {/if}
                </div>
                <div>
                  <div>R$</div>
                  <div>
                    {discount?.amount || discount?.amount === 0
                      ? formatCurrency(discount?.amount / price?.installments)
                      : price
                      ? formatCurrency(price.price / price?.installments)
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mobile-only">
            <div class="checkout__total">
              <div>Total</div>
              <div>
                <div>
                  {#if discount?.amount !== 0 && price?.recurringInterval !== "MONTH"}
                    {price?.installments}x
                  {/if}
                </div>
                <div>
                  <div>R$</div>
                  <div>
                    {discount?.amount || discount?.amount === 0
                      ? formatCurrency(discount?.amount / price?.installments)
                      : price
                      ? formatCurrency(price.price / price?.installments)
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {#if price?.guaranteeDays}
            <div class="checkout__satisfaction-message">
              <div>
                <Icon
                  data="{HeartIcon}"
                  size="24px"
                  stroke="transparent"
                  fill="#FFFFFF" />
                Garantimos a sua satisfação
              </div>
              <div>
                Garantimos a sua satisfação! Se não gostar do serviço, poderá
                pedir seu dinheiro de volta em até 14 dias após a compra.
              </div>
            </div>
          {/if}

          <div class="mobile-only send-button">
            <Button
              title="Assinar agora"
              type="success"
              onClick="{submit}"
              disabled="{discount?.amount === 0 &&
              phone &&
              cpf &&
              !disableSumbmit
                ? false
                : !expirationDate ||
                  !securityCode ||
                  !cardNumber ||
                  !holder ||
                  !phone ||
                  !cpf ||
                  disableSumbmit}" />

            {#if plan}
              <div class="checkout__terms">
                Declaro que li e aceitei a <a
                  href="{getProductLinks(plan, 'privacyPolicyURL')}"
                  target="_blank">Política de Privacidade</a>
                e os
                <a
                  href="{getProductLinks(plan, 'termsOfUseURL')}"
                  target="_blank">Termos.</a>
              </div>
            {/if}
          </div>
        </div>
      </div>
    </div>
  {/if}
  <div class="desktop-only">
    <Footer />
  </div>
</div>
